import React from "react";

const HistoryEditModal = ({
  showEditModal,
  editingRecord,
  editForm,
  handleEditFormChange,
  handleSaveEdit,
  handleCancelEdit,
}) => {
  if (!showEditModal || !editingRecord) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">
            Edit Record
          </h3>
          <button
            onClick={handleCancelEdit}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="space-y-4">
          {/* Mother Info (Read-only) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Mother
            </label>
            <div className="px-3 py-2 bg-gray-50 dark:bg-gray-700 rounded-lg text-sm text-gray-900 dark:text-white">
              <p>{editingRecord.mother_name || "Unknown Mother"}</p>
              {editingRecord.id_ibu && (
                <p className="text-xs text-gray-500 dark:text-gray-400 font-mono mt-0.5">
                  ID Ibu: {editingRecord.id_ibu}
                </p>
              )}
            </div>
          </div>

          {/* CHP Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              CHP Name
              {editingRecord.id_user_chp && (
                <span className="text-xs text-gray-500 dark:text-gray-400 font-mono ml-2">
                  (ID User: {editingRecord.id_user_chp})
                </span>
              )}
            </label>
            <input
              type="text"
              value={editForm.chp_name || ""}
              onChange={(e) => handleEditFormChange("chp_name", e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Enter CHP name"
            />
          </div>

          {/* Count Type */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Count Type
            </label>
            <select
              value={editForm.detection_type || ""}
              onChange={(e) =>
                handleEditFormChange("detection_type", e.target.value)
              }
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            >
              <option value="">Select Count Type</option>
              <option value="mms_blister">MMS Blister</option>
              <option value="mms_bottle">MMS Botol</option>
              <option value="ttd_capsule">Capsule TTD</option>
            </select>
          </div>

          {/* Pill Count */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Pill Count *
            </label>
            <input
              type="number"
              min="1"
              max="180"
              value={editForm.pill_count}
              onChange={(e) =>
                handleEditFormChange("pill_count", e.target.value)
              }
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Enter pill count"
            />
          </div>

          {/* Source */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Method
            </label>
            <select
              value={editForm.source}
              onChange={(e) => handleEditFormChange("source", e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            >
              <option value="manual">Manual Count</option>
              <option value="ai">AI Detection</option>
              <option value="ai_with_manual_override">
                AI + Manual Override
              </option>
            </select>
          </div>

          {/* Notes */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Notes
            </label>
            <textarea
              value={editForm.notes}
              onChange={(e) => handleEditFormChange("notes", e.target.value)}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Add notes (optional)"
            />
          </div>
        </div>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={handleCancelEdit}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 rounded-lg"
          >
            Cancel
          </button>
          <button
            onClick={handleSaveEdit}
            disabled={!editForm.pill_count || editForm.pill_count < 1}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed rounded-lg"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default HistoryEditModal;
